<template>
  <div class="box">
    <profile-media v-bind="$props">
      <slot></slot>
    </profile-media>
  </div>
</template>

<script>
import ProfileMedia from "@/widgets/agenda/components/shared/ProfileMedia";

export default {
  name: "ProfileCard",

  components: {
    ProfileMedia
  },

  props: ["picture", "firstName", "lastName", "position", "company"]
};
</script>
